(function() {
    let tlDiscountCodeClone;
    
    Object.defineProperty(window, "tlDiscountCode", {
        get() {
            return tlDiscountCodeClone;
        },
        set(val) {
            if (val && !tlDiscountCodeClone) {
                tlDiscountCodeClone = val;
                val.insertWidget = () => {
                    const existingWidget = document.querySelector('salepify-discount-box');
                    if(existingWidget) return
                    const widget = document.createElement('salepify-discount-box');
                    widget.classList.add("tl-discount-code");
                    widget.innerHTML = `
                        <div class = "tl-discount-code-gift-selector-wrapper">
                        </div>
                        <div class="tl-discount-box ${window.tlDiscountCode.checkShowDiscountBox() ? "" : "tl-discount-box--hide"}">
                            <div class = "tl-discount-code-header">
                                Discounts
                            </div>
                            <div class="tl-discount-code-body">
                                <input class="tl-discount-code-box" />
                                <button class="tl-discount-code-appply_button">
                                    ${window.tlDiscountCode.translation.discount_code_box.apply_button}
                                </button>
                            </div>
                            <div class="tl-discount-code-error"></div>
                            <div class="tl-discount-code-list_applied"></div>
                        </div>
                    `

                    DiscountCodeUtils.renderWidgetToElement(".rebuy-cart__flyout-integration", window.tlDiscountCode.defaultCartPosition.defaultCartPositionDiscountBox, widget);
                    // add even for discount box of theme
                    const themeHasDiscountBox = DiscountCodeUtils.themeHasDiscountBox();
                    if(themeHasDiscountBox) {
                        const discountInput = document.querySelector(window.tlDiscountCode.themeDiscountBoxSelector.themeDiscountInput);
                        const discountButton = document.querySelector(window.tlDiscountCode.themeDiscountBoxSelector.themeDiscountButton);
                        if(discountButton) {
                            discountButton.addEventListener('click', async() => {
                                const value = discountInput.value;
                                await window.tlDiscountCode.handleClickApplyButtonElement(value);
                            })
                        }
                    }
                    // add event
                    const codeBoxElement = widget.querySelector(".tl-discount-code-box");
                    const applyButtonElement = widget.querySelector(".tl-discount-code-appply_button");
                    if(!applyButtonElement) return;
                    applyButtonElement.addEventListener('click', async () => {
                        const errorEl = document.querySelector('.tl-discount-code-error');
                        applyButtonElement.classList.add('loading');
                        applyButtonElement.disabled = true;
                        const codeValue = codeBoxElement.value.trim();
                        if(!codeValue) {
                            errorEl.innerText = 'Empty code';
                        }
                        else {
                            await window.tlDiscountCode.handleClickApplyButtonElement(codeValue);
                        }
                        applyButtonElement.classList.remove('loading');
                        applyButtonElement.disabled = false;
                    });
                }
            }
        },
        configurable: true
    });
})();